import type { ReactNode } from 'react';
import { FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { Header } from '../../components/layout/Header';
import { Sidebar } from '../../components/layout/Sidebar';
import { usePreferences } from '../../contexts/PreferencesContext';
import { HELP_LINKS } from './helpLinks';
import styles from './Help.module.css';

interface HelpCardProps {
    icon: ReactNode;
    tag: string;
    title: string;
    description: string;
    buttonLabel: string;
    href: string;
    primary?: boolean;
}

function HelpCard({ icon, tag, title, description, buttonLabel, href, primary }: HelpCardProps) {
    return (
        <article className={styles.card}>
            <div className={styles.banner} aria-hidden="true">
                {icon}
            </div>
            <div className={styles.cardBody}>
                <span className={styles.tag}>{tag}</span>
                <h2 className={styles.cardTitle}>{title}</h2>
                <p className={styles.cardDesc}>{description}</p>
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={primary ? styles.buttonPrimary : styles.buttonOutline}
                >
                    {buttonLabel}
                </a>
            </div>
        </article>
    );
}

export function Help() {
    const { t } = usePreferences();

    return (
        <div className={styles.layout}>
            <Sidebar />
            <main className={styles.main}>
                <Header />
                <div className={styles.content}>
                    <h1 className={styles.title}>{t('help.titulo')}</h1>
                    <p className={styles.subtitle}>{t('help.subtitulo')}</p>

                    <div className={styles.grid}>
                        <HelpCard
                            icon={<FaYoutube size={96} className={styles.iconYoutube} />}
                            tag={t('help.videosTag')}
                            title={t('help.videosTitulo')}
                            description={t('help.videosDesc')}
                            buttonLabel={t('help.videosBotao')}
                            href={HELP_LINKS.youtube}
                        />
                        <HelpCard
                            icon={<FiUsers size={88} className={styles.iconCommunity} />}
                            tag={t('help.comunidadeTag')}
                            title={t('help.comunidadeTitulo')}
                            description={t('help.comunidadeDesc')}
                            buttonLabel={t('help.comunidadeBotao')}
                            href={HELP_LINKS.community}
                        />
                        <HelpCard
                            icon={<FaWhatsapp size={88} className={styles.iconWhatsapp} />}
                            tag={t('help.suporteTag')}
                            title={t('help.suporteTitulo')}
                            description={t('help.suporteDesc')}
                            buttonLabel={t('help.suporteBotao')}
                            href={HELP_LINKS.support}
                            primary
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}
